import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleFieldUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchModuleFieldUpdate = createAsyncThunk(
    'moduleFieldUpdate/fetchModuleFieldUpdate',
    async ({ id, file, moduleId, Name }) => {
        const response = await ModuleFieldUpdateService(id, file, moduleId, Name)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const moduleFieldUpdateSlice = createSlice({
    name: 'moduleFieldUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleFieldUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleFieldUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleFieldUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleFieldUpdateSlice.reducer;
